import AddMonitoringForm from './AddMonitoringForm';

export default AddMonitoringForm;
